import React, { type PropsWithChildren } from 'react';
import { animated, useSpring, type SpringValues } from '@react-spring/web';
import { Box } from '@mentimeter/ragnar-ui/box';

export const AnimatedSubheading = ({
  shouldShow,
  children,
}: PropsWithChildren<{ shouldShow: boolean }>) => {
  const springVoteCounter = useSpring({
    from: { opacity: 0, scale: 0 },
    to: {
      opacity: shouldShow ? 1 : 0,
      scale: shouldShow ? 1 : 0,
    },
    delay: shouldShow ? 300 : 0,
    config: { tension: 180, friction: 18 },
  });

  return (
    <Box
      as={animated.div}
      style={springVoteCounter as SpringValues}
      flexDirection="row"
      alignItems="center"
    >
      {children}
    </Box>
  );
};
